import { render, staticRenderFns } from "./GuestMedical.vue?vue&type=template&id=0579027f&"
import script from "./GuestMedical.vue?vue&type=script&lang=ts&"
export * from "./GuestMedical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports